import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';

@Component({
    selector: 'app-ecom-olar-points',
    templateUrl: './ecom-olar-points.component.html',
    styleUrls: ['./ecom-olar-points.component.scss']
})
export class EcomOlarPointsComponent implements OnInit {

    modalRef: BsModalRef;
    orderId: any;
    OlarPointsHistory: any;
    selectedOrder: any;
    showPopup: any = false;
    // component class properties
    timeleft = '';
    statusCheckMessage = '';
    status = false;
    paylater = false;
    locationSelected: any;
    userServiceBase: UserServiceBase;
    userSelectedStore: StoreServiceBase;
    config_sm = {
        animated: true,
        class: 'modal-dialog-centered modal-sm'
    };
    config = {
        animated: true,
        class: 'modal-dialog-centered'
    };
    serviceType: any;

    orderDetails: any;
    timeoutFunc: any;
    GetStatusDisable = true;
    progressStartTime: any;
    progressEndTime: any;
    orderStatus = '';
    alerts: any[] = [{
        type: 'warning',
        msg: 'service started',
        timeout: 5000,
        isOpen: false
    }];
    autoStatusTimeOut: any;
    paymentStatus = '0';
    cashbackamount = 0;
    invoiceMsg = '';
    invoiceRequest = true;
    currency = '';
    position = 'FRONT';
    orderDatetime = '';
    LogoPath = '';
    invoiceNumber = '';
    CompanyBusinessNumber = '';
    taxList = [];
    separateDialCode = true;
    SearchCountryField = SearchCountryField;
    selectedCountryISO: any = CountryISO.Malaysia;
    preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
    refererinput = {
        name: '',
        dial_code: '',
        mobile: '',
        company_guid: '',
        company_id: '',
        key: ''
    };
    settings: any;
    referralDiscount: any;
    surcharges: any;
    rejectreason = '';
    discountsApplied: any;
    emailForm: FormGroup;
    paymentMethod = undefined;
    constructor(private eComGoogleAnalytics: EComGoogleAnalytics, public formBuilder: FormBuilder, public router: Router, public ecomservice: EComService, private cookie: EcomCookies,
        public webstorage: EComWebStorage, public _sanitizer: DomSanitizer, private modalService: BsModalService) {
        this.userSelectedStore = new StoreServiceBase();
        this.userServiceBase = new UserServiceBase();
        this.userSelectedStore.storeCart = new StoreCartBase();
    }

    ngOnInit() {
        let gTag = {
            'event': 'screen_view',
            'screen_name': 'olar points history'
        };
        this.eComGoogleAnalytics.customEvent(gTag);
        if (!this.webstorage.sessionSt_is_session_valid) {
            this.router.navigate(['home']);
        }
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.LoadPage();

        this.emailForm = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator])]
        });
    }

    LoadPage() {
        if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
            const url = EcomNetworkUtils.POST_GENERATEKEY;
            this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
                if (response.isSuccess) {
                    if (!this.webstorage.localSt_client_id) {
                        this.webstorage.localSt_client_id = response.listValue.oock_client_id;
                    }
                    // store public key
                    this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
                    this.GetOlarPointsHistory();
                }
            });
        } else {
            this.GetOlarPointsHistory();
        }
    }

    // Get available Olar points
    GetOlarPointsHistory() {
        this.OlarPointsHistory = [];
        this.ecomservice.httpGet(EcomNetworkUtils.GET_OLAR_POINTS_HISTORY + "?customerGuid=" + this.webstorage.localSt_user_id, '', true).subscribe(response => {
            if (response['isSuccess']) {
                this.OlarPointsHistory = response['listValues'];
            }
        });
    }


    // Method to handle the action click event
    onActionClick(type, template, orderId, companyID) {
        // get status from db
        this.orderDetails = undefined;
        const url = EcomNetworkUtils.GET_DINEIN_COLLECTION_DELIVERY_STATUS + '?companyId=' + companyID + '&serviceId=' + orderId;
        this.ecomservice.httpGet(url, '', true).subscribe(response => {
            if (response['status'] === 403) {
                this.router.navigate(['unauthorized']);
            } else {
                this.orderDetails = response.listValue;
                this.paymentMethod = response.listValue.order_payment_method;
                this.discountsApplied = response.listValue.list_olarme_cashback_discount;
                this.referralDiscount = response.listValue.olarme_cashback_discount;
                this.rejectreason = response.listValue.oodcdr_reject_notes;
                this.surcharges = response.listValue.sales_orders.sales_order_surcharges;
                this.taxList = response.listValue.ListOrderTax;
                if (response.listValue.Position) {
                    this.position = response.listValue.Position;
                }
                if (response.listValue.Currency) {
                    this.currency = response.listValue.Currency;
                }
                this.invoiceNumber = response.listValue.sales_orders.sales_order_id;
                this.LogoPath = response.listValue.CompanyLogoPath;
                this.orderDatetime = response.listValue.order_date_time;
                this.paymentStatus = response.listValue.Payments.oodcdrp_status;
                this.CompanyBusinessNumber = response.listValue.CompanyBusinessNumber;
                // user details
                if (!this.userServiceBase) {
                    this.userServiceBase = new UserServiceBase();
                }
                this.userServiceBase.userName = response.listValue.oodcdr_name;
                this.userServiceBase.userMobile = response.listValue.oodcdr_mobile;
                this.userServiceBase.userAddress = response.listValue.oodcdr_address;
                this.userServiceBase.userCity = response.listValue.oodcdr_city;
                this.userServiceBase.userPostalCode = response.listValue.oodcdr_postal_code;
                //location details

                this.userSelectedStore.serviceDatetime = response.listValue.oodcdr_time;
                const serviceDatetime = new Date(this.userSelectedStore.serviceDatetime);
                this.userSelectedStore.serviceEstimatedDatetime = new Date(serviceDatetime.setMinutes(serviceDatetime.getMinutes() + response.listValue.DineInEndTime));
                this.userSelectedStore.storeCart.orderId = response.listValue.sales_orders.sales_order_number;
                this.userSelectedStore.serviceCompanyName = response.listValue.CompanyName;
                this.userSelectedStore.serviceLocationName = response.listValue.LocationName;
                this.userSelectedStore.serviceLocationAddress = response.listValue.LocationAddress;
                this.userSelectedStore.serviceLocationContact = response.listValue.LocationContact;
                this.userSelectedStore.serviceLocationTableName = response.listValue.TableName;
                this.userSelectedStore.storeCart.orderItems = [];
                response.listValue.sales_orders.mm_sales_order_items.forEach(item => {
                    const objItem = new ItemBase();
                    objItem.itemName = item.soi_item_name;
                    objItem.quantity = Number(item.mm_sales_order_items_standard_composite_variant_service_details[0].soiscvsd_quantity);
                    objItem.priceEach = Number(item.mm_sales_order_items_standard_composite_variant_service_details[0].soiscvsd_price);
                    objItem.totalPrice = Number(objItem.priceEach * objItem.quantity);
                    // variant
                    objItem.variantList = [];
                    item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
                        const objVariant = new VariantBase();
                        objVariant.variantName = variant.soiscvsd_name;
                        objItem.variantList.push(objVariant);
                    });

                    // modifier set
                    objItem.modifierSetList = [];
                    item.mm_sales_order_modifier_mapping.forEach(modSet => {
                        const objModifierSet = new ModifierSetBase();
                        objModifierSet.modifierName = modSet.somm_modifier_name;
                        objModifierSet.modifierOptions = [];
                        modSet.mm_sales_order_modifier_mapping_options.forEach(option => {
                            if (option.sommo_quantity > 0) {
                                const objModifierSetOption = new ModifierSetOptionBase();
                                objModifierSetOption.optionName = option.sommo_option_name;
                                objItem.totalPrice = Number(objItem.totalPrice + (option.sommo_price * option.sommo_quantity));
                                objModifierSet.modifierOptions.push(objModifierSetOption);
                            }
                        });

                        objItem.modifierSetList.push(objModifierSet);
                    });
                    this.userSelectedStore.storeCart.orderItems.push(objItem);
                });
                this.userSelectedStore.storeCart.orderDeliveryCharge = Number(response.listValue.sales_orders.sales_order_delivery_charge_total);
                this.userSelectedStore.storeCart.orderServiceCharge = Number(response.listValue.sales_orders.sales_order_surcharge_total);
                this.userSelectedStore.storeCart.orderTax = Number(response.listValue.sales_orders.sales_order_tax_total);
                this.userSelectedStore.storeCart.orderSubTotal = Number(response.listValue.sales_orders.sales_order_gross_total);
                this.userSelectedStore.storeCart.orderTotal = Number(response.listValue.sales_orders.sales_order_net_total_amount);
                this.cashbackamount = Number(response.listValue.oodcdr_cashback_discount_total_amount);
                let orderTotalAmount = 0;
                let delTax = response.listValue.ListOrderTax.find(obj => {
                    return obj.TaxGuid === response.listValue.sales_orders.sales_order_delivery_tax_guid;
                });
                if (response.listValue.tax_type === 'TAX_IN') {
                    orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total) + Number(response.listValue.sales_orders.sales_order_delivery_tax_amount);
                } else {
                    if (delTax === undefined) {
                        orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_tax_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total) + Number(response.listValue.sales_orders.sales_order_delivery_tax_amount);
                    } else {
                        orderTotalAmount = orderTotalAmount + Number(response.listValue.sales_orders.sales_order_gross_total) + Number(response.listValue.sales_orders.sales_order_tax_total) + Number(response.listValue.sales_orders.sales_order_delivery_charge_total);
                    }
                }
                if (response.listValue.list_olarme_cashback_discount) {
                    response.listValue.list_olarme_cashback_discount.forEach(element => {
                        orderTotalAmount = orderTotalAmount - Number(element.ooocd_amount)
                    });
                }
                this.userSelectedStore.storeCart.orderTotal = Number(orderTotalAmount) < 0 ? 0 : Number(orderTotalAmount);
                this.userSelectedStore.storeCart.orderDiscountTotal = Number(response.listValue.oodcdr_menu_discount_amount);
                this.serviceType = response.listValue.oodcdr_type;
                switch (type) {
                    case 'VIEW_RECEIPT':
                        this.modalRef = this.modalService.show(template);
                        break;
                }
            }
        });
    }

    onSendEmailClick(companyId, orderGuid, orderType) {
        if (this.emailForm.invalid) {
            Object.keys(this.emailForm.controls).forEach(key => {
                this.emailForm.get(key).markAsDirty();
            });
            return;
        } else {
            const input = {
                CompanyId: companyId,
                OrderGuid: orderGuid,
                Type: orderType,
                Email: this.emailForm.value.email
            };
            this.ecomservice.httpPost(EcomNetworkUtils.POST_SEND_INVOICE, input, '', true).subscribe(response => {
                if (response['status'] === 403) {
                    this.router.navigate(['unauthorized']);
                } else {
                    if (response.isSuccess) {
                        this.invoiceMsg = 'Email sent successfully, check your inbox';
                        this.invoiceRequest = true;
                        //this.closeInvoicAuto();
                    } else {
                        this.invoiceRequest = false;
                        this.invoiceMsg = 'Error in sending email try after sometime';
                    }
                }
            });
        }
    }

    onDownloadPdfClick(companyId, orderGuid, orderType) {
        const input = {
            CompanyId: companyId,
            OrderGuid: orderGuid,
            Type: orderType,
            Email: ''
        };
        this.ecomservice.httpPost(EcomNetworkUtils.POST_PRINT_PREVIEW, input, '', true).subscribe(response => {
            if (response['status'] === 403) {
                this.router.navigate(['unauthorized']);
            } else {
                if (response.isSuccess) {
                    const linkSource = 'data:application/pdf;base64,' + response['listValue'].replace(/\s/g, '');
                    const downloadLink = document.createElement("a");
                    const fileName = "Invoice.pdf";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.invoiceMsg = 'Invoice Generated Successfully';
                    this.invoiceRequest = true;
                    //this.closeInvoicAuto();
                } else {
                    this.invoiceRequest = false;
                    this.invoiceMsg = 'Error in generating invoice try after sometime';
                }
            }
        });
    }

    closeReceiptModal() {
        this.modalRef.hide();
        //$('.modal').css({"display": "none"});
        this.invoiceMsg = '';
    }
}
